__turbopack_context__.v({
  "button": "ZhQtrW_button",
  "button__squared": "ZhQtrW_button__squared",
  "buttonaccent": "ZhQtrW_buttonaccent",
  "buttonprimary": "ZhQtrW_buttonprimary",
  "buttonsecondary": "ZhQtrW_buttonsecondary",
  "buttonsecondary--selected": "ZhQtrW_buttonsecondary--selected",
  "buttontertiary": "ZhQtrW_buttontertiary",
  "disabledBtn": "ZhQtrW_disabledBtn",
  "extraMargin": "ZhQtrW_extraMargin",
  "fullWidth": "ZhQtrW_fullWidth",
  "noMinWidth": "ZhQtrW_noMinWidth",
  "selected": "ZhQtrW_selected",
  "useCheckmark": "ZhQtrW_useCheckmark",
});
